export default "__VITE_ASSET__PGTTqGTn__";